// Financial Reporting tab (key "financial-ops") — ONE surface: Report Requests.
//
// B3 issues a request, the borrower fulfils it as one bundled request in their
// portal inbox, and B3 reviews it item by item right here. Replaces the retired
// catalog-driven receipt ledger (BorrowerReportingInboundSection), whose read
// paths accrued obligations.
//
// The outbound FR-series produce-and-file suite (stat tiles, due strip, per-series
// create → preview → submit → certify & file) is NOT gone — it lives on
// /portfolio-admin/reporting, at portfolio scope, which is where it is worked.

import type { LoanSummaryDto } from "@/api/portfolioAdmin/types";
import { ReportRequestsSection } from "../financialReporting/ReportRequestsSection";

interface FinancialReportingTabProps {
  loan: LoanSummaryDto;
}

export function FinancialReportingTab({ loan }: FinancialReportingTabProps) {
  return (
    <div className="flex flex-col gap-space-4" data-testid="financial-reporting-tab">
      <ReportRequestsSection loan={loan} />
    </div>
  );
}
